module.exports = __webpack_public_path__ + "media/sub7-5-2.96d9b468.mp4";